import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@mui/material';
import { ElementType } from 'react';

import { Statistic, getValue } from './Statistics';

export type PortfolioStatistic = Statistic & { icon?: ElementType };

export default function PortfolioStatistics({ statistics }: { statistics: PortfolioStatistic[] }) {
  return (
    <dl className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-5">
      {statistics.map(stat => {
        const Icon = stat.icon;

        return (
          <div
            key={stat.label}
            className="flex flex-col gap-3 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm"
          >
            <dt className="flex items-start gap-2">
              {Icon && (
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-indigo-50 text-indigo-600">
                  <Icon className="h-4 w-4" aria-hidden="true" />
                </span>
              )}
              <span className="flex min-h-8 items-center gap-1">
                <span className="text-xs font-medium leading-tight text-gray-500">
                  {stat.label}
                </span>
                {stat.helperText && (
                  <Tooltip title={stat.helperText} placement="top">
                    <InformationCircleIcon className="h-4 w-4 shrink-0 text-gray-400" />
                  </Tooltip>
                )}
              </span>
            </dt>
            <dd className="whitespace-nowrap text-2xl font-semibold tracking-tight text-gray-900">
              {getValue(stat.value, stat.type, stat.navigateTo, stat.customValue)}
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
